export function fieldHasChanges(a, b) {
  return JSON.stringify(a) !== JSON.stringify(b);
}
//# sourceMappingURL=fieldHasChanges.js.map